export const TIERS = {
  FREE: "free",
  PREMIUM: "premium",
  PRO: "pro",
};

export const BILLING_CYCLES = {
  MONTHLY: "monthly",
  YEARLY: "yearly",
};

export const YEARLY_RENEWAL_WINDOW_DAYS = 30;
export const YEARLY_RENEWAL_MODE = "yearly_extension";

export const SUBSCRIPTION_STATUS = {
  ACTIVE: "active",
  CANCELLED: "cancelled",
  EXPIRED: "expired",
  PENDING: "pending",
  SUSPENDED: "suspended",
};

export const TIER_PRICES = {
  [TIERS.FREE]: { monthly: 0, yearly: 0 },
  [TIERS.PREMIUM]: { monthly: 9.15, yearly: 6.99 },
  [TIERS.PRO]: { monthly: 16.99, yearly: 12.99 },
};

export const YEARLY_TOTALS = {
  [TIERS.PREMIUM]: 83.88,
  [TIERS.PRO]: 155.88,
};

export const CURRENCY = "EUR";

export const BANK_TRANSFER_DETAILS = Object.freeze({
  accountHolder: "Sportyshop Sports Marketing",
  iban: "BE22 9670 6147 7047",
  bic: "TRWIBEB1XXX",
  bankName: "Wise",
  bankAddress: "Rue du Trône 100, 3rd floor, Brussels, 1050, Belgium",
});

export const TIER_LIMITS = {
  [TIERS.FREE]: {
    maxMatchesPerDay: Infinity,
    canEditMatchmakingSettings: false,
    maxMapsDisabled: 0,
    maxLocationsDisabled: 0,
    minMapsSelected: Infinity,
    minLocationsSelected: Infinity,
    captainPriority: false,
    canRequestEloRecalibration: false,
    priorityQueueWeight: 0,
  },
  [TIERS.PREMIUM]: {
    maxMatchesPerDay: Infinity,
    canEditMatchmakingSettings: true,
    maxMapsDisabled: 5,
    maxLocationsDisabled: null,
    minMapsSelected: 3,
    minLocationsSelected: 3,
    captainPriority: false,
    canRequestEloRecalibration: false,
    priorityQueueWeight: 0,
  },
  [TIERS.PRO]: {
    maxMatchesPerDay: Infinity,
    canEditMatchmakingSettings: true,
    maxMapsDisabled: 7,
    maxLocationsDisabled: null,
    minMapsSelected: 1,
    minLocationsSelected: 1,
    captainPriority: true,
    canRequestEloRecalibration: true,
    priorityQueueWeight: 1,
  },
};

export const TIER_DISPLAY = {
  [TIERS.FREE]: {
    name: "Free",
    color: "#8C8F8A",
    badge: null,
  },
  [TIERS.PREMIUM]: {
    name: "Premium",
    color: "#E8A33D",
    badge: "PREMIUM",
    profileBadge: "PREMIUM MEMBER",
  },
  [TIERS.PRO]: {
    name: "Pro",
    color: "#FFD700",
    badge: "PRO",
    profileBadge: "PRO MEMBER",
  },
};

export const PLAN_FEATURES = {
  [TIERS.FREE]: [
    "Unlimited matchmaking access",
    "Default matchmaking settings",
    "All maps and locations active",
    "Standard queue placement",
  ],
  [TIERS.PREMIUM]: [
    "Full matchmaking settings access",
    "Premium tier servers",
    "Refine down to 3 active maps",
    "Refine down to 3 active server locations",
    "Expanded queue control",
  ],
  [TIERS.PRO]: [
    "Everything in Premium",
    "Premium tier servers",
    "Captain priority in team",
    "ELO recalibration requests",
    "Can refine down to 1 active map",
    "Can refine down to 1 active server location",
    "Priority queue placement",
    "Pro profile badge",
  ],
};

export const PAYMENT_METHODS = {
  PAYPAL: "paypal",
  BANK_TRANSFER: "bank_transfer",
};
